import { Capacitor } from '@capacitor/core';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const productionHostnames = new Set([
  'fboterminaladvertising.com',
  'www.fboterminaladvertising.com',
  'privatejet.media',
  'www.privatejet.media'
]);
const isNativeApp = Capacitor.isNativePlatform();
const isProductionRuntime = isNativeApp || productionHostnames.has(hostname);

const apiUrl = process.env.REACT_APP_API_URL || (
  isProductionRuntime ? 'https://fboterminaladvertising.com/' : 'http://localhost:3300/'
);
const appUrl = process.env.REACT_APP_URL || (
  isProductionRuntime ? 'https://fboterminaladvertising.com/' : 'http://localhost:3000/'
);

const config = {
  basename: '/',
  defaultPath: '/admin',

  API_URL: apiUrl,
  API_IP_URL: process.env.REACT_APP_API_IP_URL || apiUrl,
  URL: appUrl,

  VAPID_PUBLIC_KEY: "BIi9KhTvxtDix9sIdKVSgIT9qviytX1ED1dLsu4IAElem-TDTJZFBgFOtN91_YwfDviewKbpd-8DTXD-kGznWRg",

  APP_VERSION: 'v1.20.0'
  
};

export default config;
